export default __webpack_public_path__ + "static/harley-1a932e674efb8ccb6f793ebb9a93785f.png";